module.exports = {"130271100":"海北镇","130271450":"新华路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130271.json
// module id = 178
// module chunks = 0